"use strict";
const InputBaseControl = require("@gluenetworks/input_base_control").Base;
const Renderer = require("./TimePickerRenderer");
const moment = require("moment");
const _ = require("lodash");

class TimePickerComponent extends InputBaseControl {
    constructor(config) {
        super(config);
        this._views = ["hours", "minutes"];
        this._view = config && config.view ? config.view : this._views[0]; // hours or minutes
        if (!(this._value instanceof moment)) {
            this._value = moment();
        }
        if (config && config.time && config.time && moment(config.value).isValid()) {
            this._value.set(config.time);
        }
        if (config && config.view && this._views.includes(config.view)) {
            this._view = config.view;
        }
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get view() {
        return this.getView();
    }

    set view(v) {
        this.setView(v);
    }

    getView() {
        return this._view;
    }

    setView(v) {
        if (this._views.includes(v)) {
            switch (v) {
                case "hours":
                    this._view = "hours";
                    this.emit("ShowHours");
                    break;
                case "minutes":
                    this._view = "minutes";
                    this.emit("ShowMinutes");
                    break;
            }
            this.emit("View", this._view);
        }
        return this;
    }

    showHours() {
        this.setView("hours");
    }

    showMinutes() {
        this.setView("minutes");
    }

    enable() {
        this.setDisabled(false);
    }

    disable() {
        this.setDisabled(true);
    }

    setValue(timeObj, wasTriggeredByUser, event) {
        let newVal;
        if (timeObj instanceof moment) {
            newVal = {
                hour: timeObj.hour(),
                minute: timeObj.minute(),
            };
        } else {
            newVal = timeObj;
        }
        let prev = this._value.clone();
        let change = false;
        if (newVal.hour) {
            this._value.set("hour", newVal.hour);
            change = true;
        }
        if (!_.isNil(newVal.minute)) {
            this._value.set("minute", newVal.minute);
            change = true;
        }
        if (change) {
            this.emit("Value", this._value, prev, wasTriggeredByUser);
            if (wasTriggeredByUser) {
                this._triggerUserValue(this._value, prev, event);
            }
        }
        return this;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = this._renderer.shutdown();
        this._renderer = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = TimePickerComponent;
